import { render, staticRenderFns } from "./Home.data-manager-pid.vue?vue&type=template&id=d807b31e&scoped=true&"
import script from "./Home.data-manager-pid.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-pid.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager-pid.vue?vue&type=style&index=0&id=d807b31e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d807b31e",
  null
  
)

export default component.exports